// pp-mis-disenos.js — pinta «Mis Diseños» (/pages/cliente-disenos).
//
// GET /apps/crm/customer-disenos → { borradores: Tarjeta[], comprados: Tarjeta[] }
//   Tarjeta = { id, nombre, mockup_url, producto{nombre, sku}, updated_at,
//               abrir_url (firmada, caduca en 30 min), compras?[{cantidad, fecha, orden}] }
// La pertenencia la decide el edge con el cliente firmado (borradores: solo
// los suyos; comprados: los de su empresa). Aquí solo se presenta. Por eso la
// lista se pide al abrir la página y NO se guarda en caché: `abrir_url` caduca.
(function () {
  'use strict';

  var ENDPOINT = '/apps/crm/customer-disenos';

  // ── Puras (las prueba tests/mis-disenos.test.mjs) ───────────────────────
  function fechaCorta(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try { return new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'short', year: 'numeric' }).format(d).replace('.', ''); }
    catch (e) { return ''; }
  }

  // Solo se navega a una URL del estudio. Una abrir_url rara (o null) deja la
  // tarjeta sin liga en vez de mandar al cliente a otro lado.
  function urlSegura(u) {
    return typeof u === 'string' && u.indexOf('https://print.parapaquetes.com/estudio/') === 0 ? u : null;
  }

  // «2 paquetes · 3 oct 2026 · #152916» de la compra más reciente.
  function lineaCompra(compras, T) {
    var c = compras && compras[0];
    if (!c) return '';
    var n = Number(c.cantidad);
    var partes = [];
    if (isFinite(n) && n > 0) partes.push(n + ' ' + (n === 1 ? T.paquete : T.paquetes));
    var f = fechaCorta(c.fecha);
    if (f) partes.push(f);
    if (c.orden) partes.push(c.orden);
    return partes.join(' · ');
  }

  var puras = { fechaCorta: fechaCorta, urlSegura: urlSegura, lineaCompra: lineaCompra };
  if (typeof window !== 'undefined') window.PPMisDisenos = puras;
  if (typeof document === 'undefined') return;

  // ── DOM ─────────────────────────────────────────────────────────────────
  var raiz = document.querySelector('[data-pp-disenos]');
  if (!raiz) return;
  if (window.Shopify && window.Shopify.designMode) return;
  var T = {};
  Array.prototype.forEach.call(raiz.attributes, function (a) {
    if (a.name.indexOf('data-t-') !== 0) return;
    T[a.name.slice(7).replace(/-(\w)/g, function (m, c) { return c.toUpperCase(); })] = a.value;
  });

  function el(tag, clase, texto) {
    var n = document.createElement(tag);
    if (clase) n.className = clase;
    if (texto) n.textContent = texto;
    return n;
  }

  function tarjeta(d, comprado) {
    var url = urlSegura(d.abrir_url);
    var t = el(url ? 'a' : 'div', 'pp-disenos__tarjeta');
    if (url) t.href = url;
    var fig = el('div', 'pp-disenos__img');
    if (d.mockup_url) {
      var img = el('img');
      img.src = d.mockup_url; img.alt = ''; img.loading = 'lazy';
      fig.appendChild(img);
    }
    t.appendChild(fig);
    var cuerpo = el('div', 'pp-disenos__cuerpo');
    cuerpo.appendChild(el('p', 'pp-disenos__nombre', d.nombre || (d.producto && d.producto.nombre) || T.sinNombre));
    if (d.producto && d.producto.nombre && d.nombre) cuerpo.appendChild(el('p', 'pp-disenos__producto', d.producto.nombre));
    var meta = comprado ? lineaCompra(d.compras, T) : (fechaCorta(d.updated_at) ? T.editado.replace('{fecha}', fechaCorta(d.updated_at)) : '');
    if (meta) cuerpo.appendChild(el('p', 'pp-disenos__meta', meta));
    if (url) cuerpo.appendChild(el('span', 'pp-disenos__cta', comprado ? T.volver : T.seguir));
    t.appendChild(cuerpo);
    return t;
  }

  function pintar(cual, lista, comprado) {
    var caja = raiz.querySelector('[data-pp-disenos-' + cual + ']');
    var vacio = raiz.querySelector('[data-pp-disenos-' + cual + '-vacio]');
    caja.textContent = '';
    if (!lista.length) { caja.hidden = true; vacio.hidden = false; return; }
    lista.forEach(function (d) { caja.appendChild(tarjeta(d, comprado)); });
  }

  fetch(ENDPOINT, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
    .then(function (res) {
      var d = res.d || {};
      if (!res.ok || !Array.isArray(d.borradores) || !Array.isArray(d.comprados)) throw new Error('lista');
      pintar('borradores', d.borradores, false);
      pintar('comprados', d.comprados, true);
    })
    .catch(function () {
      ['borradores', 'comprados'].forEach(function (c) { raiz.querySelector('[data-pp-disenos-' + c + ']').hidden = true; });
      var e = raiz.querySelector('[data-pp-disenos-error]');
      e.textContent = T.error; e.hidden = false;
    });
})();
